import { Link } from "react-router-dom";
import { AWARD } from "../data/rooms";

// Slim espresso strip above the hero: laurel mark · WINNER · Best Destination Coliving 2026 · Coliving Awards
// `hiring` adds a quiet "We're hiring" link on the right (homepage only).
const AwardBanner = ({ testid = "award-banner", hiring = false }) => (
  <div className="award-banner relative overflow-hidden bg-[#2E2A26] py-2.5 px-4" data-testid={testid}>
    <span className="award-shimmer pointer-events-none absolute inset-y-0 w-1/3" aria-hidden="true" />
    <div className="relative max-w-6xl mx-auto flex items-center justify-center gap-3 text-center">
      <Link
        to="/sojourns"
        className="hidden md:inline-flex absolute left-0 top-1/2 -translate-y-1/2 items-center gap-1.5 text-xs text-[#F4ECE2]/70 hover:text-[#F4ECE2] transition-colors"
        data-testid="banner-sojourns-link"
      >
        <span className="font-label text-[9px] tracking-[0.24em] uppercase text-[#C89B7B]">New</span>
        <span>Savi Sojourns, spring 2027 →</span>
      </Link>
      <img src="/images/laurel-wreath.webp" alt="" className="w-6 h-6 object-contain opacity-90 flex-shrink-0" aria-hidden="true" />
      <p className="flex items-center flex-wrap justify-center gap-x-2 gap-y-0.5 text-xs sm:text-sm leading-none">
        <span className="font-label text-[9px] sm:text-[10px] tracking-[0.28em] uppercase text-[#C89B7B]">{AWARD.status}</span>
        <span className="font-serif italic text-base sm:text-lg text-[#F4ECE2] leading-none">{AWARD.category} {AWARD.year}</span>
        <span className="hidden sm:inline text-[#C89B7B]/55">· {AWARD.body}</span>
      </p>
      {hiring && (
        <Link
          to="/careers"
          className="hidden md:inline-flex absolute right-0 top-1/2 -translate-y-1/2 items-center gap-1.5 text-xs text-[#F4ECE2]/70 hover:text-[#F4ECE2] transition-colors"
          data-testid="banner-hiring-link"
        >
          <span className="font-label text-[9px] tracking-[0.24em] uppercase text-[#C89B7B]">Hiring</span>
          <span>See the role →</span>
        </Link>
      )}
    </div>
    <span className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#C89B7B]/70 to-transparent" aria-hidden="true" />
  </div>
);

export default AwardBanner;
